import React, { useState, useEffect, useRef } from "react" ;
import axios from 'axios'
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

const PaypalCheckoutMain = ({amountTotal, hsk, hskNumber}) => {
    const CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_FRONTEND
    //console.log('client id')
    const [show, setShow] = useState(false);
    const [success, setSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState(false);
    const [ErrorMessage, setErrorMessage] = useState("");
    const [orderID, setOrderID] = useState(false);

    const [formattedDate, setFormattedDate] = useState('');
    const [message, setMessage] = useState(null);
    const [isDisabled, setIsDisabled] = useState(false);

    const [isChecked, setIsChecked] = useState(false);
    const [showCheckboxError, setShowCheckboxError] = useState(false);
    const checkboxRef = useRef(null); 
    
    //const isPayPalDisabled = isDisabled || (!agreed && !isChecked);

    const [agreed, setAgreed] = useState(false);
    const [agreedDatabase, setAgreedDatabase] = useState(false);

    const [agreementLoaded, setAgreementLoaded] = useState(false);
    
         useEffect(() => {
          //console.log('agree')
          const didAgree = async () => {
              try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND}/checkAgreement`);
                if (response.data.agreed) {
                  //console.log('agreed')
                  //console.log('response.data.agreed', response.data.agreed)
                  if(response.data.agreed === 1){
                    //console.log('agreed 1')
                    //console.log('here 1', response.data.agreed)
                    setAgreed(true);
                    setAgreedDatabase(true)
                  }
                }
              } catch (error) {
                console.error('Error checking agreement', error.message);
              } finally {
                setAgreementLoaded(true); // ✅ mark it as loaded
              }
            };
    
          didAgree();
        }, []);
    
        const handlePayPalClick = (data, actions) => {
          const agreedNow = checkboxRef.current?.checked;
    
          //console.log('agreed', agreed)
    
          //console.log('disabled', isDisabled)
    
          //console.log('isChecked', isChecked)
    
          if (agreed !== true){
            //console.log('agreed', agreed)
            if (!agreedNow) {
              //console.log ('setShowCheckboxError true')
              setShowCheckboxError(true);
              //console.log('reject')
              return actions.reject(); // 🛑 Prevent PayPal window from opening
            }
          }
    
          //console.log('false')
          setShowCheckboxError(false);
    
          //console.log('agree')
          return actions.resolve(); // ✅ Allow PayPal to proceed
        };

    const createOrder = async () => {
        try {
          //console.log('I am trying to create order')
            const res = await axios.post(`${process.env.REACT_APP_BACKEND}/paypal/create-order`, {
                amount: amountTotal,
                hsk: hskNumber
            });
            //console.log("✅ PayPal order created:", res.data);
            return res.data.id;
        } catch (err) {
            console.error("Create Order Error:", err);
            throw err;
        }
    };

    const onApprove = async (data) => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_BACKEND}/paypal/capture-order`, {
                orderID: data.orderID,
            });
             setSuccess(true);
        } catch (err) {
            console.error("Capture Order Error:", err);
        }
    };

    const onError = (err) => {
        console.error("PayPal Error:", err);
    };

    useEffect(() => {
      //console.log('success console')
        if (success) {
            setAgreed(true)
            setMessage("Your payment succeeded")
            setIsDisabled(true);
            //alert("Payment successful!!");
            //console.log('Order successful . Your order id is--', orderID);
            const fetchPaymentAndAnother = async () => {
                let formattedDateConst;
                try {
                  const response = await axios.get(`${process.env.REACT_APP_BACKEND}/setThePaymentDate?hsk=${hsk}`);
                  
                  //console.log('theExpirationDate', response.data.expirationDate)
                  if (response.data.expirationDate) {
                    const theExpirationDate = response.data.expirationDate;
                    //console.log('theExpirationDate', response.data.expirationDate)
                    
                    const formatDate = (dateString) => {
                      // Convert the date string to a Date object
                      const date = new Date(dateString);
                      
                      const year = date.getFullYear();
                      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
                      const day = String(date.getDate()).padStart(2, '0');
                      
                      return `${year}.${month}.${day}`;
                    };
              
                    // Format the expiration date
                    formattedDateConst = formatDate(theExpirationDate);
                    setFormattedDate(formattedDateConst);
                    //console.log('theExpirationDate formatted', formattedDateConst);

                    if(agreedDatabase === false){
                    try {
                      await axios.post(`${process.env.REACT_APP_BACKEND}/recordAgreement`, 
                      {
                          expirationDate: formattedDateConst
                      });

                    } catch (error) {
                      console.error('recordAgreement failed:', error.message);
                    }}

                    try {
                        await axios.post(`${process.env.REACT_APP_BACKEND}/sendPaymentVerifyEmail`, 
                        {
                            expirationDate: formattedDateConst,
                            hsk: hskNumber
                        });
                    } catch (error) {
                      console.error('sendPaymentVerifyEmail failed:', error.message);
                      }
                  } else {
                    //console.log('Mistake in setting date')
                  }
                } catch (error) {
                  console.error('Error', error.message);
                }
              };
              
              // Call the async function
              fetchPaymentAndAnother();
            }
    },[success]);

    let isPayPalDisabled;

    if (isDisabled) {
      //console.log('1')
      isPayPalDisabled = true;
    } else if (agreed) {
      //console.log('2')
      isPayPalDisabled = false;
    } else if (isChecked) {
      //console.log('3')
      isPayPalDisabled = false;
    } else {
      //console.log('4')
      isPayPalDisabled = true;
    }

    return (
        <div className="wrapper">
            {agreementLoaded && (
            <div className={`paypal-container ${isDisabled ? 'disabled' : ''}`}>
              <PayPalScriptProvider
            options={{
                "client-id": process.env.REACT_APP_PAYPAL_CLIENT_FRONTEND,
                currency: "EUR",
                intent: "capture",
                components: "buttons",
                locale: "en_RU",
                "enable-funding": "card", 
                "disable-funding": "sepa,paylater,credit,bancontact,blik,eps,giropay,ideal,mercadopago,mybank,p24,sofort,venmo" 
                }}
            >
                    <PayPalButtons
                        style={{ 
                            layout: "vertical", 
                            shape:   'rect',
                            height: 40,
                        }}
                        className="buttonsPaypal"
                        onClick={handlePayPalClick} // ⬅️ key line
                        disabled={isPayPalDisabled}
                        createOrder={createOrder}
                        onApprove={onApprove}
                        onError={onError}
                    />
                    </PayPalScriptProvider>
            </div>)}
        {message && <div className="succededPaymentDivPaypal"><div className="succededPayment">{message}</div><div className="succededPaymentDate">Payment is valid till {formattedDate}</div></div>}
        <div className={agreed === true ? "notDisplayed" : "agreement-container"}>
        <input
            type="checkbox"
            id="terms-checkbox"
            ref={checkboxRef}
            className="agreement-checkbox"
            checked={isChecked}
            onChange={(e) => {
            setIsChecked(e.target.checked);
            setShowCheckboxError(false);
            }}
        />
        <label htmlFor="terms-checkbox" className="agreement-label">
            I have read and agree to the{" "}
            <a
            href="/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="linkToTerms"
            >
            Terms and Conditions
            </a>.
        </label>
        </div>

        {showCheckboxError && (
        <div className="checkbox-error-message">
            Please agree to the Terms and Conditions to proceed with payment.
        </div>
        )}
        </div>
    );
}

export default PaypalCheckoutMain